import * as React from 'react';
import { FormGroup } from '../../components/decorators/FormGroup';
import { useFieldError } from '../hooks/errors';
import { jsx as _jsx } from "react/jsx-runtime";
export function FinalFormGroup({
  name,
  ...props
}) {
  const error = useFieldError(name);
  return /*#__PURE__*/_jsx(FormGroup, {
    ...props,
    name: name,
    error: error
  });
}